module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-public-qa"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-public-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home.qa.title")))]), _c('a', {
    staticClass: "view-more",
    on: {
      "click": _vm.onPublicQA
    }
  }, [_vm._v(_vm._s(_vm.$t("home.view_more")) + " >>")])]), _c('div', {
    staticClass: "box-public-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])]), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])]), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])]), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])]), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])]), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12 box-parent-public"
  }, [_c('div', {
    staticClass: "box-item-public",
    on: {
      "click": _vm.onPublicOne
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })])])]), _c('div', {
    staticClass: "clearfix"
  }), _c('a', {
    staticClass: "view-more mobile",
    on: {
      "click": _vm.onPublicQA
    }
  }, [_vm._v(_vm._s(_vm.$t("home.view_more")) + " >>")])])]), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "beehive"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/home/ic_mark_hoidap.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4c59ff6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Body/QAPublic/index.vue
// module id = 1644
// module chunks = 0